<template>
  <div v-if="custommerContractLoaded && summaryVisibility === summaryVisibilityOptions.BLOCK">
    <BlockedOrder />
  </div>
  <div v-else-if="getProductLoaded && loaded" class="mb-5">
    <form-steps @stepChange="setCurrent" :class="currentStep === stepType.LOGIN ? 'd-none': null" />
    <form autocomplete="on" class="main-form">

    <div v-if="getTypeForm === 'productPage'" class="row">
      <div v-if="!custommerContractLoaded || !isGuestLoaded">Ładowanie...</div>
      <ValidationObserver tag="div" vid="observer_1" ref="observer_1">
        <step1 :pageType="getTypeForm" v-if="custommerContractLoaded && isGuestLoaded"></step1>
      </ValidationObserver>
      <h2>{{ isVirtualCard && getTypeForm !== 'form' ?  'Podsumowanie wyceny' : 'Podsumowanie zamówienia' }}</h2>
      <Summary v-if="custommerContractLoaded && isGuestLoaded"></Summary>
    </div>

    <div v-if="getTypeForm === 'form'" class="row orderForm stepWrapper">
    <div :class="stepContainerClass">
      <confection-incentive-modal :open.sync="isIncentiveModalOpen" />
      <confection-reset-modal :open.sync="isConfectionResetModalOpen" />
      <contract-modal :open.sync="isContractModalOpen" :productId="this.product.idproducts" />
      <customizable-picture-alert v-if="showCustomizablePictureAlert" />
      <ValidationObserver tag="div" ref="global" v-slot="observer">
        <template v-for="(step, i) in stepsList">
          <div
            v-if="isGuest || i !== stepType.LOGIN"
            :key="i"
            :class="currentStep !== i ? 'd-none' : ''"
          >
            <h2
              class="step-title"
              :class="currentStep === stepType.LOGIN ? 'd-none': null"
            >
              {{ getStepTitle(i, step) }}
            </h2>
            <h4 class="step-subtitle" v-if="getStepSubtitle(i)">{{ getStepSubtitle(i) }}</h4>
            <CustomAlert class="form-error-alert" type="warning" :open.sync="errorModal">
              <h4>Sprawdź ponownie uzupełnione dane</h4>
              <p v-for="(error, index) in errorData" :key="index" v-html="error"></p>
            </CustomAlert>
            <div v-if="(!custommerContractLoaded || !isGuestLoaded) && currentStep === stepType.START">Ładowanie...</div>
            <div class="row header-row" v-if="isVirtualCard && getTypeForm !== 'form' && currentStep === stepType.START">
              <div class="col-xs-12">
                <accordion-pager @next="onNext"></accordion-pager>
              </div>
            </div>
            <ValidationObserver tag="div" :vid="`${'observer_' + (i + 1)}`" :ref="`observer_${i + 1}`">
              <component
                :is="'step' + (i + 1)"
                :pageType="getTypeForm"
                v-if="custommerContractLoaded && isGuestLoaded"
                @continue="(i) => currentStep === stepType.LOGIN && onNext(i)"
              >
                <template #continueAsGuest v-if="currentStep === stepType.LOGIN">
                  <accordion-pager btnType="inverse-primary" @next="onNext">Kontynuuj</accordion-pager>
                </template>
                <template #continue v-if="currentStep === stepType.LOGIN">
                  <accordion-pager btnType="inverse-primary" @next="onNext">Kontynuuj</accordion-pager>
                </template>
              </component>
            </ValidationObserver>
          </div>
        </template>
      </ValidationObserver>
    </div>
    <div
      :class="currentStep === stepType.LOGIN ? 'd-none' : ''"
      class="col-md-5 col-lg-4 sideSummary"
    >
      <div class="sideSummary__wrapper">
        <h2 class="step-title">{{ isVirtualCard && getTypeForm !== 'form' ?  'Podsumowanie wyceny' : 'Podsumowanie zamówienia' }}</h2>
        <Summary v-if="custommerContractLoaded && isGuestLoaded" :with-products="summaryVisibility !== summaryVisibilityOptions.HIDE">
          <template #continue>
            <ValidationObserver
              v-if="currentStep === stepType.START || currentStep === stepType.DELIVERY"
              vid="observer_summary"
              ref="observer_summary"
            >
              <Isgiftcheckbox v-if="currentStep === stepType.START" />
              <additional-info-agreements v-if="currentStep === stepType.DELIVERY"/>
            </ValidationObserver>
            <accordion-pager :pageType="getTypeForm" @next="onNext"></accordion-pager>
            <order-button v-if="currentStep === stepType.SUMMARY" />
          </template>
        </Summary>
      </div>
    </div>
  </div>
    </form>
  </div>
  <div v-else> Ładowanie... </div>
</template>

<script>

import { mapGetters, mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Step3 from '../../views/step3/step3.vue';
import Step2 from '../../views/step2/step2.vue';
import Step5 from '../../views/step5/step5.vue';
import Step1 from '../../views/step1/step1.vue';
import Summary from '../Summary/Summary.vue';
import Step4 from '../../views/step4/step4.vue';
import Step6 from '../../views/step6/step6.vue';
import AccordionPager from './AccordionPager.vue';
import BlockedOrder from '@/components/BlockedOrder/BlockedOrder.vue';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import ErrorModal from '../Modals/ErrorModal.vue';
import CustomAlert from '../CustomAlert.vue';
import CustomizablePictureAlert from '../CustomizablePictureAlert.vue';
import { checkProductsIsVirtualCard, checkProductsIsEVoucher } from '@/utils/categoryUtils';
// eslint-disable-next-line import/extensions
import ConfectionResetModal from '@/components/Modals/ConfectionResetModal.vue';
import Isgiftcheckbox from '@/components/Checkboxes/IsGiftCheckbox/IsGiftCheckbox.vue';
import FormSteps from '../FormSteps/FormSteps.vue';
import AdditionalInfoAgreements from '../AdditionalInfoForm/AdditionalInfoAgreements.vue';
import OrderButton from '../OrderButton/OrderButton.vue';
import ConfectionIncentiveModal from '@/components/Modals/confectionIncentiveModal.vue';
import ContractModal from '@/components/Modals/ContractModal.vue';
import { DataLayerManager } from '@/utils/DataLayerManager';
import { summaryVisibilityOptions } from '@/utils/constants/summary';
import {
  getShouldResetConfection,
  setShouldResetConfection,
  getShouldResetForm,
  setShouldResetForm,
} from '@/store/sore-helpers';
import { getContractIdFromUrl, hasCustomizablePicture, shouldShowContractModal } from '@/utils/contract/nde';

const configElement = document.getElementById('config');
const config = JSON.parse(configElement.innerHTML);
const backendValidation = RepositoryFactory.get('validation');

export default {
  name: 'Accordion',
  components: {
    Isgiftcheckbox,
    BlockedOrder,
    ErrorModal,
    ConfectionResetModal,
    ContractModal,
    CustomAlert,
    CustomizablePictureAlert,
    AccordionPager,
    Summary,
    FormSteps,
    AdditionalInfoAgreements,
    OrderButton,
    Step1,
    Step2,
    Step3,
    Step4,
    Step5,
    Step6,
    ConfectionIncentiveModal,
  },

  data() {
    return {
      showAccordion: [],
      errorModal: false,
      errorData: [],
      isConfectionResetModalOpen: false,
      isIncentiveModalOpen: false,
      isContractModalOpen: false,
      loaded: false,
    };
  },
  computed: {
    ...mapState({
      stepsList: state => state.steps.stepsList,
      currentStep: state => state.steps.currentStep,
      stepType: state => state.steps.stepType,
      isGuest: state => state.cart.userIsGuest,
      isGuestLoaded: state => state.cart.userIsGuestLoaded,
      deliveries_no: state => state.cart.deliveries_no,
      custommerContractLoaded: state => state.customer.loaded,
      summaryVisibility: state => state.customer.contract.summary_option,
      shouldShowIncentiveModal: state => state.confection.shouldShowIncentiveModal,
      contract: state => state.customer.contract,
    }),
    ...mapGetters(['getProductLoaded']),
    ...mapFields('bankNumber', ['showVatExceptionCheckbox']),
    getTypeForm() {
      return config.type;
    },
    editedOrderId() {
      return config.order_id;
    },
    isEVoucher() {
      return checkProductsIsEVoucher(this.product);
    },
    stepContainerClass() {
      switch (this.currentStep) {
        case this.stepType.START:
          return 'col-md-8 productStepWrapper';
        case this.stepType.LOGIN:
          return 'col-12 loginStepWrapper';
        default:
          return 'col-md-7 col-lg-8';
      }
    },
    product() {
      if (!this.getProductLoaded) return null;
      return this.$store.state.products.all.products[0];
    },
    isProductNde() {
      return this.$store.getters.isProductNDE;
    },
    isVirtualCard() {
      if (!this.getProductLoaded) return false;
      return checkProductsIsVirtualCard(this.product);
    },
    areConfectionItemsInCart() {
      const confectionItems = this.$store.getters['delivery/getOnlyConfectionItems'];
      return confectionItems.length > 0 && confectionItems.some(item => item.quantity > 0);
    },
    hasConfection() {
      const hasConfection = this.product.confection.length > 0;
      const hasConfectionServices = this.product.confectionService.length > 0;
      return hasConfection || hasConfectionServices;
    },
    allProductsIds() {
      const allProducts = this.$store.getters.allProductsFlat;
      const ids = new Set(allProducts.map(item => String(item ? item.idproducts : '')));
      return ids;
    },
    showCustomizablePictureAlert() {
      return this.currentStep === this.stepType.START && hasCustomizablePicture(this.contract);
    },
  },
  async created() {
    this.$store.dispatch('confection/setShouldShowIncentiveModal', true);
    this.summaryVisibilityOptions = summaryVisibilityOptions;
  },
  async mounted() {
    this.$store.dispatch('additionalInfo/resetDangerousFields');
    this.$store.dispatch('delivery/initDelivery', this.deliveries_no);
    await this.$store.dispatch('cart/setUserIsGuest');
    if (this.currentStep === this.stepType.START) DataLayerManager.pushViewCartEvent();

    if (this.editedOrderId) await this.setEditedOrderData(this.editedOrderId);

    const contractId = getContractIdFromUrl();
    await this.$store.dispatch('getAllProducts', contractId);
    this.removeNonExistentProductsFromCart();
    this.removeNonExistentAdditionalProducts();

    this.loaded = true;

    if (!this.editedOrderId) {
      if (getShouldResetForm()) this.handleFormReset();
      if (getShouldResetConfection()) this.handleConfectionReset();
    }

    this.showAccordion = this.stepsList.map((item, idx) => idx === 0);
    this.showAccordion.forEach((item, index) => {
      // eslint-disable-next-line no-unused-expressions
      this.currentStep === index ? this.showAccordion[index] = true : this.showAccordion[index] = false;
    });

    if (this.$store.getters['delivery/getItemsCount'] > 0 && this.getTypeForm === 'form' && this.currentStep === this.stepType.START) {
      if (this.isGuest) this.setCurrent(this.stepType.LOGIN);
      else this.setCurrent(this.stepType.INVOICE);
    }

    if (!this.editedOrderId && this.isProductNde && shouldShowContractModal(contractId, this.contract)) {
      this.openContractModal();
    }
  },
  methods: {
    async setEditedOrderData(orderId) {
      await this.$store.dispatch('loadOrderData', orderId);
    },
    removeNonExistentProductsFromCart() {
      const itemsInCart = this.$store.getters['delivery/getItemsAll'];

      itemsInCart.forEach(async (item) => {
        const itemMainId = String(item.id).split('-')[0];
        if (!this.allProductsIds.has(itemMainId)) {
          await this.$store.dispatch('delivery/deleteProductFromCart', [item, item.iddelivery]);
        }
      });
    },
    removeNonExistentAdditionalProducts() {
      const additionalProducts = this.$store.getters.additionalProductsFlat;

      additionalProducts.forEach(async (item) => {
        const itemMainId = String(item.id).split('-')[0];
        if (!this.allProductsIds.has(itemMainId)) {
          await this.$store.dispatch('removeAdditionalProduct', item.id);
        }
      });
    },
    handleConfectionReset() {
      setShouldResetConfection(false);
      if (!this.areConfectionItemsInCart) return;
      this.$store.dispatch('confection/resetConfection');
      this.$store.dispatch('delivery/resetConfectionChoice');
      this.$store.dispatch('delivery/resetDeliveryFile');
      this.openConfectionResetModal();
    },
    handleFormReset() {
      setShouldResetForm(false);
      this.$store.dispatch('delivery/reset');
      this.$store.dispatch('confection/resetConfection');
      this.$store.dispatch('delivery/resetConfectionChoice');
      this.$store.dispatch('virtualCard/reset');
      this.$store.dispatch('cart/reset');
    },
    openConfectionResetModal() {
      this.isConfectionResetModalOpen = true;
    },
    openContractModal() {
      this.isContractModalOpen = true;
    },
    toggleAccordion(index) {
      if (this.showAccordion[index]) {
        this.$set(this.showAccordion, index, false);
      } else {
        this.showAccordion = this.showAccordion.map((v, i) => i === index);
        this.$store.dispatch('steps/setCurrentStep', index);
      }
    },
    getStepTitle(stepNumber, stepName) {
      switch (stepNumber) {
        case this.stepType.DELIVERY:
          if (this.isVirtualCard || this.isEVoucher) return 'Dostarczenie produktu';
          return stepName;
        case this.stepType.SUMMARY:
          return 'Sprawdź zanim zamówisz';
        default:
          return stepName;
      }
    },
    getStepSubtitle(stepNumber) {
      switch (stepNumber) {
        case this.stepType.INVOICE:
          return 'Wypełnij poniższy formularz aby dokończyć składanie zamówienia.';
        case this.stepType.DELIVERY:
          if (this.isEVoucher || this.isVirtualCard) return null;
          return 'Wypełnij ten formularz, abyśmy wiedzieli gdzie dostarczyć Twoje produkty.';
        case this.stepType.SUMMARY:
          return `Prosimy o sprawdzenie wszystkich danych, oraz opłacenie zamówienia. Zamówienie zostanie zrealizowane
          po otrzymaniu płatności. Zmiana lub anulowanie zamówienia po dokonaniu płatności nie będzie możliwa,
          jak również niemożliwy będzie zwrot czy wymiana produktów.`;
        default:
          return null;
      }
    },
    setCurrent(index) {
      this.errorModal = false;
      if (this.currentStep > index) this.$store.dispatch('steps/setCurrentStep', index);
    },
    validateStep(index) {
      let data = null;

      switch (index) {
        case this.stepType.START + 1:

          if (this.isVirtualCard) {
            const virtualCardData = [
              {
                vc_token: this.$store.state.virtualCard.vc_token,
                ...this.$store.state.delivery,
              },
              this.$store.state.cart,
            ];

            data = virtualCardData;
          } else {
            data = [this.$store.state.delivery, this.$store.state.cart, this.$store.state.confection];
          }

          break;
        case this.stepType.LOGIN + 1:
          data = [this.$store.state.delivery, this.$store.state.cart, this.$store.state.confection];
          break;
        case this.stepType.INVOICE + 1:
          data = [this.$store.state.fvForm, this.$store.state.contactPerson, this.$store.state.bankNumber, this.$store.state.products.all];
          break;
        case this.stepType.DELIVERY + 1:
          data = [this.$store.state.delivery];
          break;
        case this.stepType.ADDITIONAL_INFO + 1:
          data = [this.$store.state.additionalInfo, this.$store.state.products, this.$store.state.delivery, this.$store.state.cart, this.$store.state.confection];
          break;
        default:
          return true;
      }

      return data;
    },
    async onNext(index) {
      if (this.hasConfection && this.shouldShowIncentiveModal && !this.areConfectionItemsInCart) {
        this.$store.dispatch('confection/setShouldShowIncentiveModal', false);
        this.isIncentiveModalOpen = true;
        return;
      }
      this.errorModal = false;
      let idx = index;
      if (idx === this.stepType.START + 1 || idx === this.stepType.DELIVERY + 1) {
        const isSummaryObserverValid = await this.$refs.observer_summary.validate();
        if (!isSummaryObserverValid) return;
      }
      const observerName = `observer_${idx}`;
      this.$refs[observerName][0].validate().then((data) => {
        if (data) {
          if ((!this.isGuest && idx === this.stepType.LOGIN) || idx === this.stepType.ADDITIONAL_INFO) {
            idx += 1;
          }
          if (this.validateStep(idx) !== true) {
            backendValidation.validate(idx, this.validateStep(idx)).then((result) => {
              if (result.data !== true) {
                this.errorData = (result.data && result.data.errors) || [];
                this.showVatExceptionCheckbox = !!(result.data && result.data.vatExceptionCheckbox);
                this.errorModal = true;
              } else {
                this.$store.dispatch('steps/setCurrentStep', idx);
              }
            });
          } else {
            this.$store.dispatch('steps/setCurrentStep', idx);
          }
          this.scrollToTop();
        } else {
          this.errorModal = true;
          this.errorData = ['Nie wszystkie pola formularza zostały wypełnione prawidłowo.'];
          this.scrollToFirstError(observerName);
        }
      });

      if (index === this.stepType.SUMMARY) {
        this.$store.dispatch('cart/setSummary');
      }
    },
    scrollToFirstError(observerName) {
      const firstInvalidKey = Object.keys(this.$refs[observerName][0].fields).filter(key => this.$refs[observerName][0].fields[key].invalid)[0];
      if (firstInvalidKey) {
        const firstInvalidEl = this.$refs[observerName][0].refs[firstInvalidKey].$el;
        if (firstInvalidEl) {
          firstInvalidEl.scrollIntoView({ block: 'center' });
        }
      }
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    /* TO DELETE BEFORE PRODUCTION */
    setStep(step) {
      this.$store.dispatch('steps/setCurrentStep', step);
    },
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    currentStep(newValue, oldValue) {
      this.toggleAccordion(newValue);

      switch (this.currentStep) {
        case this.stepType.START:
          DataLayerManager.pushViewCartEvent();
          break;

        case this.stepType.LOGIN:
          DataLayerManager.pushBeginCheckoutEvent();
          break;

        case this.stepType.INVOICE:
          if (!this.isGuest) DataLayerManager.pushBeginCheckoutEvent();
          DataLayerManager.pushCheckoutStep2Event();
          break;

        case this.stepType.DELIVERY:
          DataLayerManager.pushAddPaymentInfoEvent();
          break;

        case this.stepType.ADDITIONAL_INFO:
          break;

        case this.stepType.SUMMARY:
          DataLayerManager.pushAddShippingInfoEvent();
          break;

        default:
          break;
      }
    },
  },
};
</script>


<style lang="scss">
 //@import '../../_html/assets/css/adw/helpers/colors';
 //@import '../../_html/assets/css/adw/vue-app/index';

.header-row > div {

  h3 {
    flex:1;
  }

  display: flex;
  justify-content: space-between;
  align-items: center;
}
 .propductPageHeader {
   display: flex;
   justify-content: space-between;
   align-items: center;
   width: 100%;
   margin-top: 20px;

   > div:first-child {
     flex: 1;
   }

   .accordion-pager {
     margin-top: 0;
   }

 }
</style>
